import { render, staticRenderFns } from "./modelSource.vue?vue&type=template&id=0353a43c"
import script from "./modelSource.vue?vue&type=script&lang=js"
export * from "./modelSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports